import React from 'react';
import { Link } from 'react-router';
import useTranslate from '../../useTranslate';
import { LocationOverviewDto } from '../../../store/locationsSlice';
import { Mansion } from '../../../store/mansionsSlice';
import { LocationDescriptor } from 'history';

export interface LocationAndMansion {
    location: LocationOverviewDto;
    mansion?: Mansion;
    targetLink: LocationDescriptor;
}

interface Props {
    locationsWithMansion: LocationAndMansion[];
}

function SelectLocationTable(props: Readonly<Props>) {
    const strings = useTranslate('SelectLocationPricing');
    if (props.locationsWithMansion.length < 1) {
        return <p>{strings.no_locations}</p>;
    }

    return (
        <table className="data-table" style={{ width: '100%' }}>
            <thead>
                <tr>
                    <th>{strings.name}</th>
                    <th>{strings.address}</th>
                    <th>{strings.prices}</th>
                    <th> </th>
                </tr>
            </thead>
            <tbody>
                {props.locationsWithMansion.map(
                    ({ location, mansion, targetLink }: LocationAndMansion) => {
                        const address = mansion?.address;
                        const address1 = address
                            ? `${address.street} ${address.housenumber}`
                            : '';
                        const address2 = address
                            ? `${address.postalcode} ${address.city}`
                            : '';
                        return (
                            <tr key={location.id}>
                                <td>{location.name}</td>
                                <td>
                                    {address1}
                                    <br />
                                    {address2}
                                </td>
                                <td>
                                    {`${strings.washing}: ${strings._utils.formatPrice(
                                        {
                                            amount: location.washer_cost,
                                            currency:
                                                location.currency_type || 'EUR',
                                        }
                                    )}`}
                                    <br />
                                    {`${strings.drying}: ${strings._utils.formatPrice(
                                        {
                                            amount: location.dryer_cost,
                                            currency:
                                                location.currency_type || 'EUR',
                                        }
                                    )}`}
                                    <br />
                                </td>
                                <td>
                                    <Link
                                        to={targetLink}
                                        className="icon icon-wew-button-enter icon-sm"
                                    />
                                </td>
                            </tr>
                        );
                    }
                )}
            </tbody>
        </table>
    );
}

export default SelectLocationTable;
